// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc89a40a","453":"a3ae4db9","455":"88731b08","977":"daf459c7"}[chunkId] + ".chunk.js";
};